import { createFileRoute } from '@tanstack/react-router';

import { TemplatesPage } from '@/features/templates/pages/TemplatesPage';

export const Route = createFileRoute('/_authenticated/templates/')({
  component: TemplatesPage,
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/templates', title: 'Templates' }],
  }),
});
